import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { installGlobalErrorReporting } from './lib/clientErrors.js';
import { SessionProvider } from './session/SessionProvider.js';

/*
 * The website's three typefaces, self-hosted - ruling B. Bundled from
 * fontsource, so the browser fetches them from app.entitylinks.com and nothing
 * else: no Google Fonts, no third-party request. The weights are the website's,
 * plus Plex Sans 500, which the portal's `font-medium` labels use.
 */
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';

import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('No #root element. index.html is not what the bundle expects.');
}

// C-32. Errors nothing else caught: a throw in an event handler, a promise nobody
// awaited. Render errors reach the boundary below instead.
installGlobalErrorReporting();

createRoot(container).render(
  <StrictMode>
    {/* Outside the router and the session on purpose: either of them failing
        is exactly the case this needs to catch. */}
    <ErrorBoundary>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
